import { TextFilter } from "./base";
import { FilterViewProps } from "./base/types";

interface SimpleTextFilterProps {
  label: string;
  helperText?: string;
}
const SimpleTextFilter = (simpleProps: SimpleTextFilterProps) => {
  const Filter = (props: FilterViewProps) => {
    return <TextFilter {...props} {...simpleProps} />;
  };
  return Filter;
};

export default SimpleTextFilter;
